import { isString } from "@ciaopeople/cp-shatsu/TypeChecking";

export type CPNetworks = {
    cookist: boolean,
    fanpage: boolean,
    ohga: boolean,
    wamily: boolean,
    geopop: boolean,
    corporate: boolean,
    kodami: boolean,
    lexplain: boolean
};


const networkChecker: CPNetworks = {
    cookist: true,
    fanpage: true,
    ohga: true,
    wamily: true,
    geopop: true,
    corporate: true,
    kodami: true,
    lexplain: true
}


export type CPNetworkName = keyof CPNetworks;


export function isValidCPNetwork(x: any): x is CPNetworkName {
    return isString(x) && (x in networkChecker);
}